import React from 'react';
import { Switch } from 'antd';
import { RuleSwitch, RuleWrapper } from './style';
import { onChangeParent } from './form.handler';

const Index = (props) => {
  const { rule, accessGroup, setAccessGroup, onChange, disabled } = props;
  return (
    <RuleWrapper key={rule?.id}>
      <RuleSwitch>
        <div>
          <p className="font-subtitle2_medium black2">{rule?.name}</p>
          <p className="font-paragraph black3">{rule?.desc}</p>
        </div>
      </RuleSwitch>
      <div className="containers_users_roleForm_ruleWrapper_grid">
        {rule?.rules &&
          rule.rules?.map((subRule) => {
            const checked = accessGroup?.find((item) => {
              return item?.id === subRule?.id;
            });
            return (
              <RuleSwitch small key={subRule?.id}>
                <p className="font-paragraph black2">{subRule?.name}</p>
                <Switch
                  size="small"
                  className="component_switch_child"
                  onChange={(isChecked) => {
                    if (onChange) {
                      onChange();
                    }
                    onChangeParent({
                      isChecked,
                      rule: subRule,
                      setAccessGroup,
                    });
                  }}
                  checked={checked}
                  disabled={disabled}
                />
              </RuleSwitch>
            );
          })}
      </div>
    </RuleWrapper>
  );
};

export default Index;
